export class MissedAuditRowDetail {
    public PeriodStart: Date;
    public PeriodEnd: Date;
    public TotalCompleted: number;
    public CompletedInPeriod: boolean;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}